import { render, staticRenderFns } from "./googleYoutubeVedio.vue?vue&type=template&id=8191cab6"
import script from "./googleYoutubeVedio.vue?vue&type=script&lang=js"
export * from "./googleYoutubeVedio.vue?vue&type=script&lang=js"
import style0 from "./googleYoutubeVedio.vue?vue&type=style&index=0&id=8191cab6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports